export enum RoleFields {
    ID = "id",
    NAME = "name",
    PRODUCT_FEATURE_COUNT = "productFeatureCount",
}
